const webhook = 'webhook';
const authentication = 'auth';
const analytic = 'analytic';

//Auth
export const login = `${authentication}/login`;
export const auth_google_token = `${authentication}/google/token`;
export const refresh_token_url = `${authentication}/refresh-token`;
export const reset_password = `${authentication}/reset-password`;
export const reset_password_ticket = `${authentication}/reset-password-ticket`;
export const account = `${authentication}/account`;
export const resendVerification = `${authentication}/resend-verification`;

//Webhook
export const webhookURL_fcm_token = `${webhook}/fcm-token`;
export const webhookURL_profile = `${webhook}/profile`;
export const webhookURL_notifications = `${webhook}/notifications`;

//analytic
export const analyticURL_analytic_collection = `${analytic}/collection`;
export const analyticURL_analytic_school_donation_collection = `${analytic}/school-donation-collection`;
export const analyticURL_analytic_top_borrower = `${analytic}/top-borrower`;
export const analyticURL_analytic_top_book_by_borrow = `${analytic}/top-book-by-borrow`;
export const analyticURL_analytic_top_category = `${analytic}/top-category`;
export const analyticURL_analytic_top_book_by_queue = `${analytic}/top-book-by-queue`;
export const analyticURL_analytic_book_borrow = `${analytic}/book-borrow`;
export const analyticURL_analytic_book_queue = `${analytic}/book-queue`;
export const analyticURL_analytic_school_user = `${analytic}/school-user`;
export const analyticURL_analytic_book_borrow_comparison = `${analytic}/book-borrow-comparison`;
export const analyticURL_analytic_book_borrower_comparison = `${analytic}/book-borrower-comparison`;
export const analyticURL_analytic_school_active = `${analytic}/school-active`;
export const analyticURL_analytic_school_mapping = `${analytic}/school-mapping`;
export const analyticURL_analytic_school_collection = `${analytic}/school-collection`;
export const analyticURL_analytic_school_member = `${analytic}/school-member`;
export const analyticURL_analytic_procurement = `${analytic}/procurement`;
export const analyticURL_analytic_book_borrow_comaparison = `${analytic}/book-borrow-comparison`;
export const analyticURL_analytic_school_info = `${analytic}/school-info`;
